"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressIndicator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("./styles");
var atoms_1 = require("../../atoms");
var DEFAULT_PROGRESS_CARD_WIDTH = "392px";
exports.ProgressIndicator = react_1.default.memo(function (_a) {
    var open = _a.open, percentComplete = _a.percentComplete, description = _a.description, action = _a.action, _b = _a.width, width = _b === void 0 ? DEFAULT_PROGRESS_CARD_WIDTH : _b;
    var classes = (0, styles_1.useStyles)({ width: width });
    return open ? ((0, jsx_runtime_1.jsxs)(core_1.Paper, __assign({ className: classes.root, elevation: 0 }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.content }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.contentLeft }, { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: classes.percentComplete }, { children: [percentComplete, "%"] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.divider }, { children: "|" })), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.currentStatus }, { children: description }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.contentRight }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.action }, { children: action })) }))] })), (0, jsx_runtime_1.jsx)(atoms_1.ProgressBar, { percentComplete: percentComplete })] }))) : null;
});
